import { Accessor, createComputed, createSignal } from "solid-js";
import { isServer } from "solid-js/web";

import UFunction from "@repo/utils/UFunction";
import UPromise from "@repo/utils/UPromise";

export default function createAsync<T, U extends T | undefined>(
  fn: () => UPromise.Maybe<T>,
  defaultValue?: U,
  { onError = UFunction.noop as (e: unknown) => void } = {}
) {
  const [value, setValue] = createSignal<T>(defaultValue as T);
  const [loading, setLoading] = createSignal(true);
  const [error, setError] = createSignal<any>();

  createComputed(async () => {
    if (isServer) return;

    setLoading(true);
    try {
      const value = await fn();
      setValue(() => value);
    } catch (e) {
      console.error(e);
      onError(e);
      setError(e);
    } finally {
      setLoading(false);
    }
  });

  return Object.assign(value as Accessor<T | U>, { loading, error });
}
